import { ColorEnum } from '@/constants/color'
import { FC } from 'react'
import { Path, PathProps } from 'react-native-svg'

const TrianglePath: FC<PathProps> = (props) => {
    return <Path fill={ColorEnum.GRAY_100} d="M10.166 0-.001 10V.003L10.166 0Z" {...props} />
}

export default TrianglePath
